const projectConfig = require('../../project.config.js');

export const branch = process.env.BRANCH_ENV || 'burgeon';
export const Version = () => (process.env.BRANCH_ENV === 'burgeon' ? '1.4' : '1.3');
export const interlocks = () => (true);
export const enableGateWay = () => (Version() === '1.4');
export const enableJflow = () => (branch === 'lining' || branch === 'kabin');
// export const jflowRequestDomain = () => (enableJflow() ? (branch == 'kabin' ? 'http://47.102.164.111:26665' : process.env.NODE_ENV === 'production' ? window.location.origin : 'http://106.15.24.156:28888') : ''); //李宁客户环境：http://jflow.cmsqas.lining.com
export const jflowRequestDomain = () => enableJflow() ? (branch == 'kabin' ? 'http://47.102.164.111:26665' : 'http://cmsdev.lining.com') : ''; //李宁客户环境：http://jflow.cmsqas.lining.com
export const jflowTabShow = () => (enableJflow());
export const custommizedJflow = () => false;
export const SURVEY_URL = `${projectConfig.SURVEY_URL || ''}`
export const SSO_URL = `${projectConfig.SSO_URL || ''}`
export const SSO_Client_Id = `${projectConfig.SSO_Client_Id || ''}`
export const TARGET_URL = `${projectConfig.liningTarget || ''}`
console.log(process.env.NODE_ENV);